export default __webpack_public_path__ + "static/media/HandBaggage_.e74efa9a.svg";